import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ListNodeView } from "@/components/editor/nodeviews/ListNodeView";

export const ListBlock = Node.create({
  name: "listBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      items: { default: [] },
      ordered: { default: false },
      labelFormat: { default: "number" },
      start: { default: 1 },
      // "bullet" | "numbered" | "description". When null/undefined, the
      // render paths derive from `ordered` (legacy back-compat). For
      // kind === "description", each item carries { text: <term>,
      // description: <body> } and labelFormat/start are ignored.
      kind: { default: null },
      // "default" | "tight" | "compact". "tight" → enumitem noitemsep
      // (compact items, normal margins). "compact" → enumitem nosep
      // (no extra space anywhere). Typst maps both to `tight: true`
      // on the corresponding list/enum/terms set rule.
      spacing: { default: "default" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="list-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "list-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ListNodeView);
  },
});
